import { gql } from "@apollo/client";

export const CREATE_SUPPLIER = gql`
  mutation CreateSupplier(
    $name: String
    $tell: String
    $address: String
    $remark: String
    $bankAccounts: [bankAccountsInput]
  ) {
    createSupplier(
      name: $name
      tell: $tell
      address: $address
      remark: $remark
      bankAccounts: $bankAccounts
    ) {
      status
      message
    }
  }
`;

export const GET_SUPPLIER_WITH_PAGINATION = gql`
  query GetSupplierPagination($page: Int, $limit: Int, $keyword: String) {
    getSupplierPagination(page: $page, limit: $limit, keyword: $keyword) {
      data {
        _id
        name
        tell
        bankAccounts {
          name
          accountNumer
          remark
        }
        address
        remark
        createdAt
      }
      paginator {
        slNo
        prev
        next
        perPage
        totalPosts
        totalPages
        currentPage
        hasPrevPage
        hasNextPage
        totalDocs
      }
    }
  }
`;

export const UPDATE_SUPPLIER = gql`
  mutation UpdateSupplier(
    $id: String!
    $name: String
    $tell: String
    $address: String
    $remark: String
    $bankAccounts: [bankAccountsInput]
  ) {
    updateSupplier(
      _id: $id
      name: $name
      tell: $tell
      address: $address
      remark: $remark
      bankAccounts: $bankAccounts
    ) {
      status
      message
    }
  }
`;

export const DELETE_SUPPLIER = gql`
  mutation DeleteSupplier($id: String!) {
    deleteSupplier(_id: $id) {
      status
      message
    }
  }
`;
